module.exports = __webpack_public_path__ + "img/phone-cover.1767ddeb.png";